module.exports = __webpack_public_path__ + "static/img/face4a.06df4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face4a.png
// module id = dYcu
// module chunks = 1